import React  from 'react';
function BMITable({classification})  {
  return (
    <table >
      <thead>
        <tr>
          <th >مؤشر كتلة الجسم (BMI)</th>
          <th >حالة التغذية (Nutritional status)</th>
        </tr>
      </thead>
      <tbody>
        <tr className={classification === 'Underweight' ? 'highlightedWarning' : ''}>
          <td>أقل من  18.5</td>
          <td>وزن غير كافٍ (Underweight)</td>
        </tr>
        <tr className={classification === 'Normal weight' ? 'highlightedOk' : ''}>
          <td>18.5–24.9</td>
          <td>وزن طبيعي (Normal weight)</td>
        </tr>
        <tr className={classification === 'Pre-obesity' ? 'highlightedWarning' : ''}>
          <td>25.0–29.9</td>
          <td> ماقبل السمنة (Pre-obesity)</td>
        </tr>
        <tr className={classification === 'Obesity class I' ? 'highlightedDanger' : ''}>
          <td>30.0–34.9</td>
          <td>السمنة الدرجة الأولى (Obesity class I)</td>
        </tr>
        <tr className={classification === 'Obesity class II' ? 'highlightedDanger' : ''}>
          <td>35.0–39.9</td>
          <td>السمنة الدرجة الثانية (Obesity class II)</td>
        </tr>
        <tr className={classification === 'Obesity class III' ? 'highlightedDanger' : ''}>
          <td>أكثر من 40</td>
          <td>السمنة الدرجة الثالثة (Obesity class III)</td>
        </tr>
        <tr>
          <td colSpan="2">
            <b>المصدر:</b>{' '}
            <a href="https://www.who.int/europe/news-room/fact-sheets/item/a-healthy-lifestyle---who-recommendations">
              منظمة الصحة العالمية
            </a>
          </td>
        </tr>
        <tr>
          <td colSpan="2">
            <b>تاريخ أخر مراجعة:</b> 28/02/2026
          </td>
        </tr>
      </tbody>
    </table>
  );
}
export default BMITable;
